// src/features/Recommended-For-You/components/RecommendedSlider.tsx

'use client'; // This is the interactive island

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ProductCard from '@/features/product-card/components/productCard';
import 'swiper/css';
import 'swiper/css/navigation';

interface Product {
  id: string | number;
  // Define other product properties here for type safety
}

interface SliderProps {
  products: Product[];
  // We need to pass the navigation class names to the slider
  // so it knows which buttons to control.
  navPrev: string;
  navNext: string;
}

export const RecommendedSlider: React.FC<SliderProps> = ({
  products,
  navPrev,
  navNext,
}) => {
  return (
    <div className="product-feature__slider">
      <Swiper
        modules={[Navigation]}
        spaceBetween={8}
        loop={true}
        slidesPerView={5} // Start with desktop view
        grabCursor={true}
        breakpoints={{
          320: { slidesPerView: 2 },
          576: { slidesPerView: 2.5, spaceBetween: 16 },
          768: { slidesPerView: 3, spaceBetween: 24 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
        }}
        speed={500}
        navigation={{
          nextEl: `.${navNext}`,
          prevEl: `.${navPrev}`,
        }}
      >
        {products?.map((product, index) => (
          <SwiperSlide key={product?.id || index}>
            <ProductCard data={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
